import { axiosInstance } from '../common/api';

export const fetchTimelineData = (data) => {
  const url = `/timeline`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const fetchManualLogs = (userId) => {
  const url = `/timeline/${userId}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const fetchMonthStats = (data) => {
  const url = `/timeline/month`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
